import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetchChannels } from '../../api/fetchChannels/fetchChannels';
import { IAddon, IChannelsResponse, IEndpoint } from '../../api/fetchChannels/types';
import { IAggregator } from '../../types/aggregator.types';
import { getBrandId } from '../../helpers/getBrandId/getBrandId';

export const useExternalSystems = (
  options?: Omit<
    UseQueryOptions<IChannelsResponse, unknown, IAggregator[], string[]>,
    'queryKey' | 'queryFn' | 'select'
  >,
) => {
  return useQuery({
    queryKey: ['external-systems', getBrandId()],
    queryFn: fetchChannels,
    staleTime: 60000, // 1 minute
    select: (response: IChannelsResponse) => {
      const externalSystems = response?.data || [];
      return externalSystems.map(
        (aggregator): IAggregator => ({
          aggregatorId: aggregator.external_system_id,
          name: aggregator.name,
          externalId: aggregator.external_id,
          description: aggregator.integration_type_name,
          integrationType: aggregator.integration_type_name,
          venues: aggregator.venues.map((venue) => ({
            venue_id: venue.venue_id,
            name: venue.name,
            is_trial: venue.is_trial,
          })),
          configuredAddons: aggregator.configured_addons.map((addon: IAddon) => ({
            addonId: addon.addon_id,
            addonName: addon.addon_name,
            endpoints: addon.endpoints.map((endpoint: IEndpoint) => {
              return {
                endpointId: endpoint.endpoint_id,
                endpointName: endpoint.name,
                lastUpdated: endpoint.last_updated,
                endpointUrl: endpoint.url,
              };
            }),
          })),
        }),
      );
    },
    ...options,
  });
};
